module.exports = __webpack_public_path__ + "static/lights-96a72c92d454f6c696a115c24875f6a6.png";